import React, {useCallback, useEffect, useRef, useState} from 'react';
import cn from "classnames";
import ReactTooltip from "react-tooltip";
import {TableHeader} from "./TableHeader";
import BackButton from "../../../../components/utils/BackButton";
import Select from "react-select";
import DateInput from "../../../../components/utils/DateInput";
import {useDispatch, useSelector} from "react-redux";
import {createInventory, fetchInventoryForm, fetchRawsListInventoryForm, recalculationInventory, updateInventory } from "../../../../action";
import {isEmpty} from "lodash";
import {ItemRow} from "./ItemRow";
import Loader from "../../../../components/utils/Loader";
import swal from "sweetalert";
import {inventoryFormSavingSelector, inventoryFormSelector} from "../../../../selectors/forms";
import {styles} from "../../../../containers/goods/styles";
import ErrorContainer from "../../../../components/utils/ErrorContainer";
import { loaderRawSelector, rawListSelector } from '../../../../selectors/raw';
import { fetchRawsList } from '../../../../action/raw';
import { fetchFilials } from '../../../../action/handbook';
import moment from 'moment';
import { roleId } from '../../../../constants/app';
import ExcelJS from 'exceljs';
import { roundToFixed } from '../../../../utils/common';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';

const InventoryForm = ({ match, history }) => {
    const {id} = match.params;
    const dispatch = useDispatch();

    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const raws = useSelector(rawListSelector);
    const isMobile = window.innerWidth <= 768;
    const user = useSelector(state => state.user.info);
    const form = useSelector(state => inventoryFormSelector(state, id));

    const rawMaterialsLoading = useSelector(loaderRawSelector);

    const [selectedPoint, setSelectedPoint] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [loadingRawsForm, setLoadingRawsForm] = useState(id ? true : false);
    const [rawsInventory, setRawsInventory] = useState([]);
    const [changeLog, setChangeLog] = useState(null);
    const [saveLoad, setSaveLoad] = useState(false);
    const loading = pointLoading || rawMaterialsLoading;
    const savingInventory = useSelector(state => inventoryFormSavingSelector(state));
    const saving = saveLoad || savingInventory;
    const unblockRef = useRef(null);
    const refImport = useRef();

    useEffect(() => {
        const handleBeforeUnload = (e) => {
          e.preventDefault();
          e.returnValue = 'Вы уверены, что хотите покинуть страницу? Изменения могут быть не сохранены.';
          return e.returnValue;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        const unblock = history.block((location, action) => {
          return 'Вы уверены, что хотите покинуть страницу? Изменения могут быть не сохранены.';
        });
        unblockRef.current = unblock;
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
          if (unblockRef.current) {
            unblockRef.current();
            unblockRef.current = null;
          }
        };
    }, [history]);

    const safeGoBack = () => {
        if (unblockRef.current) {
          unblockRef.current();
          unblockRef.current = null;
        }

        window.history.back();
    };    

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        dispatch(fetchRawsList());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
            const loadForm = async () => {
                setLoadingRawsForm(true);
                const result = await dispatch(fetchInventoryForm(id, true));
                if (result && !result.error) {
                    const rawMaterials = await dispatch(fetchRawsListInventoryForm(id));
                    if (rawMaterials) setRawsInventory(rawMaterials);
                    setSelectedDate(new Date(result.date));
                    const point = result.point && points.find((item) => item.id === (result.point.id || result.point));
                    if (point) setSelectedPoint({
                        value: point.id,
                        label: `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`,
                        enableConsumption: point.enableConsumption || false,
                    })
                    const changeLog = result.changeLog ? result.changeLog : {};
                    setChangeLog(changeLog);
                    setLoadingRawsForm(false);
                }
            };
            if (id && !isEmpty(points)) loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [dispatch, id, points]);

    const pointOptions = points.map(point => ({
        value: point.id,
        label: `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`,
        enableConsumption: point.enableConsumption || false,
    }));

    const setPoint = (point) => {
        if (point && !point.enableConsumption) return swal({
            title: `Создание списания на филиале ${point.label} невозможно`,
            text: '"Списание сырья" отключено',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });
        setSelectedPoint(point);
    }

    const semiManufactures = raws.filter((raw) => raw.productscategory.type === 'semi' && !raw.productscategory.notBalance);
    const rawMaterials = raws.filter((raw) => raw.productscategory.type === 'raw' && !raw.productscategory.notBalance);

    const groupedRawMaterials = rawMaterials.reduce((acc, rawMaterial) => {
        const categoryTitle = (rawMaterial.productscategory && rawMaterial.productscategory.title) || "Без категории";
        if (!acc[categoryTitle]) {
            acc[categoryTitle] = [];
        }
        acc[categoryTitle].push(rawMaterial);
        return acc;
    }, {});

    const groupedSemiManufactures = semiManufactures.reduce((acc, semiManufacture) => {
        const categoryTitle = (semiManufacture.productscategory && semiManufacture.productscategory.title) || "Без категории";
        if (!acc[categoryTitle]) {
            acc[categoryTitle] = [];
        }
        acc[categoryTitle].push(semiManufacture);
        return acc;
    }, {});

    const handleRecalculation = async (e) => {
        e.preventDefault();
        setSaveLoad(true);

        const rawMaterialsData = Array.from(document.querySelectorAll('[data-type="data"]')).map((row) => {
            const input = row.querySelector('input');
            const quantity = input && input.value !== '' ? parseFloat(input.value) : 0;
            const id = parseInt(row.getAttribute('data-id'));
            const raw = raws.find((item) => item.id === id);
            const type = (raw && raw.productscategory && raw.productscategory.type) ? raw.productscategory.type : 'raw';
            const last_price = (raw && raw.last_price != null) ? raw.last_price : null;
            return {
                id,
                quantity,
                last_price,
                rawData: {
                    id: (raw && raw.id) ? raw.id : null,
                    name: (raw && raw.name) ? raw.name : null,
                    categoryId: (raw && raw.productscategory && raw.productscategory.id) ? raw.productscategory.id : null,
                    categoryName: (raw && raw.productscategory && raw.productscategory.title) ? raw.productscategory.title : null,
                    type,
                    last_price: (raw && raw.last_price) ? raw.last_price : null,
                }
            }
        });
        
        const date = moment().format('YYYY.MM.DD');
        const time = moment().format('HH:mm:ss');
        const username = user ? user.name ? user.name : user.username : null;
        const currentLog = changeLog[date] || {};
        const dataToSend = {
            date: selectedDate.toISOString(),
            point: selectedPoint ? selectedPoint.value : null,
        };

        const dataLog = {
            time,
            username,
            action: 'recalculation',
        }

        currentLog.recalculation = dataLog;
        const updatedLog = { ...changeLog, [date]: currentLog };
        dataToSend.changeLog = updatedLog;

        dataToSend.rawMaterials = rawMaterialsData;

        try {
            const result = await dispatch(recalculationInventory(id, dataToSend));

            if (result && result.error) {
                setSaveLoad(false);
                return swal({
                    title: "Ошибка",
                    text: result.error.message,
                    icon: "warning",
                    button: 'Ок'
                });
            }
    
            if (result && !result.error) {
                setSaveLoad(false);
                return swal({
                    title: "Успешно!",
                    text: "Инвентаризация успешно обновлена",
                    icon: "success",
                    button: 'Ок'
                }).then(() => safeGoBack());
            }
        } catch (err) {
            console.error(err)
            setSaveLoad(false);
        }
    }

    const onExportDataForm = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Форма инвентаризации');
    
        worksheet.addRow(['id', 'Тип', 'Категория', 'Наименование', 'Ед. изм.', 'Остаток (факт.)']);
        const exportData = [];
    
        Object.entries(groupedRawMaterials).sort(([a], [b]) => a.localeCompare(b)).forEach(([key, dataRaws]) => {
            if (!isEmpty(dataRaws)) dataRaws.forEach((raw) => {
                exportData.push({ id: raw.id, type: 'Сырье', category: key, name: raw.name, measure: MEASURES_RAW[raw.measure] });
            });
        });
    
        Object.entries(groupedSemiManufactures).sort(([a], [b]) => a.localeCompare(b)).forEach(([key, dataRaws]) => {
            if (!isEmpty(dataRaws)) dataRaws.forEach((raw) => {
                exportData.push({ id: raw.id, type: 'Полуфабрикат', category: key, name: raw.name, measure: MEASURES_RAW[raw.measure] });
            });
        });
    
        if (!exportData || exportData.length === 0) return;
    
        exportData.forEach((item) => {
            worksheet.addRow([item.id, item.type, item.category, item.name, item.measure || 'шт.', '']);
        });
    
        worksheet.views = [
            { state: 'frozen', ySplit: 1 }
        ];

        worksheet.getColumn(1).hidden = true;

        const generateRandomPassword = () => {
            return String(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
        };

        const calculateRowHeight = (row, columnWidths) => {
            let maxLines = 1;

            row.eachCell((cell, colNumber) => {
                if (cell.value && typeof cell.value === 'string') {
                    const text = cell.value;
                    const colWidthInChars = columnWidths[colNumber - 1];
                    const textLength = text.length;
                    const lines = Math.ceil(textLength / colWidthInChars);
                    if (lines > maxLines) maxLines = lines;
                }
            });

            return Math.max(15, maxLines * 15);
        }
        
        const columnWidths = [ 10, 15, 15, 25, 10, 17 ];
        worksheet.getColumn(2).width = columnWidths[1];
        worksheet.getColumn(3).width = columnWidths[2];
        worksheet.getColumn(4).width = columnWidths[3];
        worksheet.getColumn(5).width = columnWidths[4];
        worksheet.getColumn(6).width = columnWidths[5];
    
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFC9C9C9' }
            };
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
    
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = {
                    ...cell.alignment,
                    wrapText: true,
                    vertical: 'middle'
                };
            });
        });
    
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell) => {
                if (rowNumber === 1) {
                    cell.protection = { locked: true };
                    row.height = 15;
                } else {
                    cell.protection = { locked: cell.col !== 6 };
                    cell.dataValidation = {
                        type: 'decimal',
                        operator: 'greaterThanOrEqual',
                        formulae: [0],
                        allowBlank: true,
                        showErrorMessage: true,
                        errorTitle: 'Ошибка ввода',
                        error: 'Поддерживаются только числовые положительные значения'
                    };
                    const height = calculateRowHeight(row, columnWidths);
                    row.height = Math.min(Math.max(height, 20), 100);
                }
            });
        });
    
        const password = generateRandomPassword()
        await worksheet.protect(password, {
            selectLockedCells: true,
            selectUnlockedCells: true,
            sort: false,
            autoFilter: false,
        });
    
        worksheet.properties.outlineProperties = { summaryBelow: false };
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Форма для заполнения инвентаризации.xlsx`;
        link.click();
    };

    const onImport = useCallback(async (e) => {
        if (!e.target.files[0]) return;

        const file = e.target.files[0];
        if (!file.arrayBuffer) return;

        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhonesImport', value: true });

            const data = await file.arrayBuffer();
            if (!data) throw new Error('Не удалось прочитать файл');

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(data);

            const worksheet = workbook.getWorksheet(1);
            if (!worksheet) throw new Error('В файле нет листов');

            const importData = [];
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) {
                    const cellNameId = row.getCell(1);
                    const cellNameValue = row.getCell(6);
                    if (cellNameId.value !== 'id' || cellNameValue.value !== 'Остаток (факт.)') throw new Error('Неверный шаблон файла, скачайте актуальный шаблон нажав на кнопку "Экспорт формы для заполнения".');
                }

                const idCell = row.getCell(1);
                const id = idCell.value !== undefined ? +idCell.value : undefined;

                const restCell = row.getCell(6);
                const name = row.getCell(4) || '';
                const type = row.getCell(2)
                let rest = restCell.value !== undefined ? parseFloat(restCell.value) : undefined;
                if (isNaN(rest)) rest = 0;

                if (id !== undefined && !isNaN(id)) importData.push({ id, name, type, rest });
            });

            if (!importData || importData.length === 0) throw new Error('Файл не содержит данных');

            return swal({
                title: "Вы импортируете данные в форму инвентаризации",
                text: "Введенные ранее данные будут заменены на данные из файла",
                icon: "warning",
                buttons: ["Отмена", "Подтвердить"],
            }).then((willImport) => {
                let notFoundRaws = [...importData];
                if (willImport) {
                    const rows = document.querySelectorAll('[data-type="data"]');
                    rows.forEach((row) => {
                        const input = row.querySelector('input');
                        const id = parseInt(row.getAttribute('data-id'), 10);
                        const raw = importData.find(item => item.id === id);
                        const value = (raw && typeof raw.rest === 'number' && !isNaN(raw.rest)) ? roundToFixed(raw.rest, 3) : 0;
                        if (input) {
                            input.value = value;
                            notFoundRaws = notFoundRaws.filter((item) => item.id !== id);
                        }
                    });

                    if (isEmpty(notFoundRaws)) {
                        return swal({
                            title: 'Успех',
                            text: `Импорт данных завершен`,
                            icon: "success",
                            button: 'OK'
                        });
                    } else {
                        const textNotFount = notFoundRaws.map((item) => `${item.type}: ${item.name}` || `${item.type}: id - ${item.id}`);
                        return swal({
                            title: 'Успех',
                            text: `Импорт данных выполнен. Не найдены данные для внесения следующих элементов: ${textNotFount.join(', ')}`,
                            icon: "warning",
                            button: 'OK'
                        });
                    }
                    
                }
            });
        } catch (error) {
            console.error('Ошибка при импорте данных:', error);
            return swal({
                title: 'Ошибка',
                text: `Ошибка при импорте данных: ${error.message || 'Неизвестная ошибка'}`,
                icon: 'error',
                dangerMode: true
            });
        }
    }, [dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaveLoad(true);
        const rawMaterialsData = Array.from(document.querySelectorAll('[data-type="data"]')).map((row) => {
            const input = row.querySelector('input');
            const quantity = input && input.value !== '' ? parseFloat(input.value) : 0;
            const id = parseInt(row.getAttribute('data-id'));
            const raw = raws.find((item) => item.id === id);
            const type = (raw && raw.productscategory && raw.productscategory.type) ? raw.productscategory.type : 'raw';
            const last_price = (raw && raw.last_price != null) ? raw.last_price : null;
            return {
                id,
                quantity,
                last_price,
                rawData: {
                    id: (raw && raw.id) ? raw.id : null,
                    name: (raw && raw.name) ? raw.name : null,
                    categoryId: (raw && raw.productscategory && raw.productscategory.id) ? raw.productscategory.id : null,
                    categoryName: (raw && raw.productscategory && raw.productscategory.title) ? raw.productscategory.title : null,
                    type,
                    last_price: (raw && raw.last_price) ? raw.last_price : null,
                }
            }
        });

        if (!id) {
            const dataToSend = {
                date: selectedDate.toISOString(),
                point: selectedPoint ? selectedPoint.value : null,
                rawMaterials: rawMaterialsData,
            };

            try {    
                const result = await dispatch(createInventory(dataToSend));
    
                if (result && result.error) {
                    setSaveLoad(false);
                    return swal({
                        title: "Ошибка",
                        text: result.error.message,
                        icon: "warning",
                        button: 'Ок'
                    });
                }
    
                if (result) {
                    setSaveLoad(false);
                    return swal({
                        title: "Успешно!",
                        text: "Инвентаризация успешно создана",
                        icon: "success",
                        button: 'Ок'
                    }).then(() => safeGoBack());
                }

                setSaveLoad(false);
            } catch (err) {
                console.error(err);
                setSaveLoad(false)
            }
        } else {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;
            const currentLog = changeLog[date] || {};
            const dataToSend = {
                date: selectedDate.toISOString(),
                point: selectedPoint ? selectedPoint.value : null,
            };

            if (moment(selectedDate).toISOString() !== moment(form.date).toISOString()) {
                const data = { 
                    old: moment(form.date).format('DD.MM.YYYY HH:mm'), 
                    new: moment(selectedDate).format('DD.MM.YYYY HH:mm'),
                    time,
                    username,
                };
                currentLog.date = data;
            }

            if (selectedPoint.value !== form.point.id) {
                const data = { 
                    old: form.point.id, 
                    new: selectedPoint.value,
                    time,
                    username,
                };
                currentLog.point = data;
            }

            const newRawMaterials = rawMaterialsData.map((dataRaw) => {
                const oldRaw = rawsInventory.find((rawInventory) => {
                    const rawId = (rawInventory.rawmaterial && rawInventory.rawmaterial.id) ? rawInventory.rawmaterial.id : (rawInventory.rawData && rawInventory.rawData.id) ? rawInventory.rawData.id : null;
                    if (rawId == null) return false;
                    return rawId === dataRaw.id
                });
                if (!oldRaw || !oldRaw.id) return {...dataRaw, isNew: true};
                if (oldRaw.quantity === dataRaw.quantity) return null;
                return { ...dataRaw, isUpdate: true };
            }).filter((item) => item);

            if (newRawMaterials && newRawMaterials.length > 0) {
                dataToSend.rawMaterials = newRawMaterials;
                newRawMaterials.forEach((raw) => {
                    const oldRaw = raw.isNew ? null : rawsInventory.find((rawInventory) => {
                        const rawId = (rawInventory.rawmaterial && rawInventory.rawmaterial.id) ? rawInventory.rawmaterial.id : (rawInventory.rawData && rawInventory.rawData.id) ? rawInventory.rawData.id : null;
                        if (rawId == null) return false;
                        return rawId === raw.id
                    });
                    const data = { 
                        id: raw.id,
                        new: raw.quantity,
                        old: oldRaw ? oldRaw.quantity : null,
                        time,
                        username,
                    };
                    currentLog.raws = [...(currentLog.raws || []), data];
                })
            } else {
                setSaveLoad(false);
                return swal({
                    title: "Ошибка",
                    icon: 'warning',
                    text: "Нет данных для обновления",
                    dangerMode: true,
                    button: 'Ок'
                })
            }

            if (!isEmpty(currentLog)) {
                const updatedLog = { ...changeLog, [date]: currentLog };
                dataToSend.changeLog = updatedLog;
            } else {
                setSaveLoad(false);
                return swal({
                    title: "Ошибка",
                    icon: 'warning',
                    text: "Нет данных для обновления",
                    dangerMode: true,
                    button: 'Ок'
                })
            }

            try {
                const result = await dispatch(updateInventory(id, dataToSend));

                if (result && result.error) {
                    setSaveLoad(false);
                    return swal({
                        title: "Ошибка",
                        text: result.error.message,
                        icon: "warning",
                        button: 'Ок'
                    });
                }
    
                if (result && !result.error) {
                    setSaveLoad(false);
                    return swal({
                        title: "Успешно!",
                        text: "Инвентаризация успешно обновлена",
                        icon: "success",
                        button: 'Ок'
                    }).then(() => safeGoBack());
                }

                setSaveLoad(false);
            } catch (err) {
                setSaveLoad(false);
                console.error(err);
            }
        }
    };

    if (loading || loadingRawsForm) return <div style={styles.formLoading}><Loader text="Загрузка бланка..." /></div>

    const renderTable = (array) => {
        return (
            <tbody className="kt-datatable__body">
                {isEmpty(array) ? (
                    <tr>
                        <td colSpan={8}>
                            <span
                                style={{margin: 15}}
                                className="kt-datatable--error">Нет данных для заполнения</span>
                        </td>
                    </tr>
                ) : (
                    Object.entries(array).sort(([a], [b]) => a.localeCompare(b)).map(([category, items]) => (
                        <React.Fragment key={category}>
                            <tr className="kt-datatable__row" style={{fontWeight: 'bold'}}>
                                <td colSpan="3" className="kt-datatable__cell">{category}</td>
                            </tr>
                            {items.sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                let quantity = item.quantity;
                                if (id) {
                                    const rawInventory = rawsInventory.find((raw) => {
                                        const rawId = (raw.rawmaterial && raw.rawmaterial.id) ? raw.rawmaterial.id : (raw.rawData && raw.rawData.id) ? raw.rawData.id : null;
                                        if (rawId == null) return false;
                                        return rawId === item.id
                                    });
                                    if (rawInventory) quantity = rawInventory.quantity;
                                }
                                return (
                                    <ItemRow
                                        key={item.id}
                                        item={{...item, quantity}}
                                        isMobile={isMobile}
                                    />
                                )
                            })}
                        </React.Fragment>
                    ))
                )}
            </tbody>
        )
    }

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
                         style={{padding: 0}}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div style={{ position: 'relative', marginBottom: 0 }} className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}>
                                    <>
                                        {isMobile ? (
                                            <div className="kt-subheader__mobile-wrapper">
                                                <div className="kt-subheader not-mt kt-grid__item">
                                                    <div className="kt-container kt-container--fluid">
                                                        <div className="kt-subheader__main">
                                                            <div className="kt-subheader__mobile-header">
                                                                <div className="kt-subheader__mobile-actions">
                                                                    <BackButton disabled={saving} />
                                                                    <button
                                                                        onClick={handleSubmit}
                                                                        className={cn({
                                                                            'btn btn-success kt-spinner--right kt-spinner--sm kt-spinner--light': true,
                                                                            'kt-spinner': saving
                                                                        })}
                                                                        disabled={saving || !selectedPoint}
                                                                    >
                                                                        {saving ? "Сохранение..." : "Сохранить"}
                                                                    </button>
                                                                    {[roleId.admin, roleId.chiefCommoditySpecialist].includes(user.role.id) && id &&
                                                                        <button onClick={handleRecalculation} className='btn btn-sm btn-icon btn-icon-md btn-secondary'>
                                                                            <i className='la la-refresh'/> 
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="kt-subheader__mobile-actions">
                                                                <div style={{width: 175}}>
                                                                    <Select
                                                                        isDisabled={id != null}
                                                                        value={selectedPoint}
                                                                        onChange={setPoint}
                                                                        options={pointOptions}
                                                                        placeholder="Все филиалы"
                                                                        isClearable={true}
                                                                        isLoading={loading}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <DateInput
                                                                        disabled={id != null}
                                                                        showPopperArrow={false}
                                                                        placeholderText="Дата"
                                                                        selected={selectedDate}
                                                                        onChange={date => setSelectedDate(date)}
                                                                        showTimeSelect
                                                                        timeFormat="HH:mm:ss"
                                                                        timeIntervals={1}
                                                                        dateFormat="dd.MM.yyyy HH:mm:ss"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="kt-subheader not-mt kt-grid__item">
                                                    <div className="kt-container kt-container--fluid">
                                                        <div className="kt-subheader__main">
                                                            <h3 className="kt-subheader__title">Форма инвентаризации</h3>
                                                            <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                            <div className="kt-subheader__group" id="kt_subheader_search">
                                                                <BackButton disabled={saving} />
                                                                <button
                                                                    onClick={handleSubmit}
                                                                    className={cn({
                                                                        'btn btn-success kt-spinner--right kt-spinner--sm kt-spinner--light': true,
                                                                        'kt-spinner': saving
                                                                    })}
                                                                    disabled={saving || !selectedPoint}
                                                                >
                                                                    {saving ? "Сохранение..." : "Сохранить"}
                                                                </button>
                                                                {[roleId.admin, roleId.chiefCommoditySpecialist].includes(user.role.id) && id &&
                                                                    <button onClick={handleRecalculation} className='btn btn-sm btn-icon btn-icon-md btn-secondary'>
                                                                        <i className='la la-refresh'/> 
                                                                    </button>
                                                                }
                                                                {!id &&
                                                                    <>
                                                                        <button
                                                                        onClick={onExportDataForm}
                                                                        disabled={saving}
                                                                        className={cn({
                                                                            'btn btn-dark kt-spinner--right kt-spinner--sm kt-spinner--light': true,
                                                                            'kt-spinner': saving
                                                                        })}
                                                                        >
                                                                            Экспорт формы для заполнения
                                                                        </button>
                                                                        <label className={`btn btn-primary btn-icon-sm ${(saving)  ? 'disabled' : ''}`}>
                                                                            <input 
                                                                                type="file" 
                                                                                onChange={onImport} 
                                                                                ref={refImport} 
                                                                                hidden
                                                                                disabled={saving}
                                                                            />
                                                                            {saving ? (
                                                                                <span>
                                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                                    {' '}Импорт...
                                                                                </span>
                                                                            ) : 'Импорт формы'}
                                                                        </label>
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="kt-subheader not-mt kt-grid__item">
                                                    <div className="kt-container kt-container--fluid">
                                                        <div className="kt-subheader__main">
                                                            <div>
                                                                <DateInput
                                                                    disabled={id != null}
                                                                    showPopperArrow={false}
                                                                    placeholderText="Дата"
                                                                    selected={selectedDate}
                                                                    onChange={date => setSelectedDate(date)}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm:ss"
                                                                    timeIntervals={1}
                                                                    dateFormat="dd.MM.yyyy HH:mm:ss"
                                                                />
                                                            </div>
                                                            <div style={{width: 175, marginLeft: 10}}>
                                                                <Select
                                                                    isDisabled={id != null}
                                                                    value={selectedPoint}
                                                                    onChange={setPoint}
                                                                    options={pointOptions}
                                                                    placeholder="Все филиалы"
                                                                    isClearable={true}
                                                                    isLoading={loading}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </>
                                    <table className="kt-datatable__table">
                                        <ErrorContainer field='inventoryForm' hasCloseButton={true} style={{ margin: 25 }}/>
                                        <TableHeader title="Сырье" isMobile={isMobile}/>
                                        {renderTable(groupedRawMaterials)}                                        
                                    </table>
                                    <table className="kt-datatable__table">
                                        <TableHeader title="Полуфабрикаты" isMobile={isMobile}/>
                                        {renderTable(groupedSemiManufactures)}
                                        <tbody className="kt-datatable__body">
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip
                        effect="solid"
                        type="dark"
                        place="top"
                    />
                </div>
            </div>
        </div>
    )
};

export default InventoryForm;
